import { useState, useEffect } from "react";
import { useTheme, DARK, LIGHT } from "../../components/Layout";
import { warehouseAPI } from "../../services/api";
import { Plus, Search, Filter, Save, X } from "lucide-react";
import PersianDatePicker from "../../utils/PersianDatePicker";
import { gregorianToJalaliStr } from "../../utils/PersianDatePicker";

const fmt=(n:any)=>new Intl.NumberFormat("en-US",{maximumFractionDigits:3}).format(Number(n)||0);

export default function TransactionsPage() {
  const { dark } = useTheme();
  const T = dark ? DARK : LIGHT;
  const [txs, setTxs]             = useState<any[]>([]);
  const [products, setProducts]   = useState<any[]>([]);
  const [warehouses, setWarehouses]= useState<any[]>([]);
  const [showAdd, setShowAdd]     = useState(false);
  const [toast, setToast]         = useState<{msg:string;ok:boolean}|null>(null);
  const [filters, setFilters]     = useState({product_id:"",warehouse_id:"",type:"",from:"",to:""});
  const [form, setForm] = useState({ product_id:"", warehouse_id:"", type:"in", quantity:"", date:"", reference:"", description:"" });

  const showToast=(msg:string,ok=true)=>{setToast({msg,ok});setTimeout(()=>setToast(null),3000);};

  const load = async()=>{
    const [rt,rp,rw] = await Promise.all([
      warehouseAPI.transactionsList(filters),
      warehouseAPI.productsList({status:"active"}),
      warehouseAPI.warehousesList(),
    ]);
    if(rt.success) setTxs(rt.transactions);
    if(rp.success) setProducts(rp.products);
    if(rw.success) setWarehouses(rw.warehouses);
  };
  useEffect(()=>{load();},[filters]);

  const inp: React.CSSProperties = { width:"100%", padding:"9px 12px", background:dark?"rgba(255,255,255,0.05)":"#f8faff", border:`1.5px solid ${dark?"rgba(255,255,255,0.08)":"rgba(0,0,0,0.08)"}`, borderRadius:8, color:T.text, fontSize:13, fontFamily:"'Vazirmatn','Segoe UI',sans-serif", direction:"rtl" as const, outline:"none", boxSizing:"border-box" as const };
  const lbl: React.CSSProperties = { fontSize:11, fontWeight:700, color:T.subtext, display:"block", marginBottom:4 };
  const card: React.CSSProperties = { borderRadius:14, padding:20, background:dark?"rgba(255,255,255,0.03)":"#fff", border:`1px solid ${T.cardBorder}`, marginBottom:14 };

  const handleAdd = async()=>{
    if(!form.product_id||!form.warehouse_id||!form.quantity){showToast("جنس، گدام و مقدار الزامی است",false);return;}
    const r = await warehouseAPI.transactionAdd(form);
    if(r.success){showToast("✅ تراکنش ثبت شد");setShowAdd(false);setForm({product_id:"",warehouse_id:"",type:"in",quantity:"",date:"",reference:"",description:""});load();}
    else showToast(r.message,false);
  };

  return (
    <div dir="rtl">
      {toast&&<div style={{position:"fixed",top:20,left:"50%",transform:"translateX(-50%)",zIndex:9999,padding:"12px 24px",borderRadius:12,background:dark?"#1e293b":"#fff",border:`2px solid ${toast.ok?"#10b981":"#ef4444"}`,boxShadow:"0 8px 32px rgba(0,0,0,0.25)",color:toast.ok?"#10b981":"#ef4444",fontSize:13,fontWeight:700,fontFamily:"inherit"}}>{toast.msg}</div>}

      {/* فرم افزودن */}
      {showAdd&&(
        <div style={{...card,borderRight:"4px solid #f59e0b",marginBottom:20}}>
          <div style={{fontSize:14,fontWeight:800,color:T.text,marginBottom:16}}>📥 ثبت ورود/خروج دستی</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:12}}>
            <div>
              <label style={lbl}>جنس *</label>
              <select value={form.product_id} onChange={e=>setForm(f=>({...f,product_id:e.target.value}))} style={{...inp,background:dark?"#1e293b":"#f8faff"}}>
                <option value="">— انتخاب جنس</option>
                {products.map(p=><option key={p.id} value={p.id}>{p.name} ({p.code})</option>)}
              </select>
            </div>
            <div>
              <label style={lbl}>گدام *</label>
              <select value={form.warehouse_id} onChange={e=>setForm(f=>({...f,warehouse_id:e.target.value}))} style={{...inp,background:dark?"#1e293b":"#f8faff"}}>
                <option value="">— انتخاب گدام</option>
                {warehouses.map(w=><option key={w.id} value={w.id}>{w.name}</option>)}
              </select>
            </div>
            <div>
              <label style={lbl}>نوع</label>
              <select value={form.type} onChange={e=>setForm(f=>({...f,type:e.target.value}))} style={{...inp,background:dark?"#1e293b":"#f8faff"}}>
                <option value="in">⬇️ ورود به گدام</option>
                <option value="out">⬆️ خروج از گدام</option>
              </select>
            </div>
            <div><label style={lbl}>مقدار *</label><input type="number" value={form.quantity} onChange={e=>setForm(f=>({...f,quantity:e.target.value}))} placeholder="0" style={{...inp,direction:"ltr" as const,fontWeight:700,fontSize:15,color:form.type==="in"?"#10b981":"#ef4444"}}/></div>
            <div><PersianDatePicker label="تاریخ *" value={form.date} onChange={v=>setForm(f=>({...f,date:v}))}/></div>
            <div><label style={lbl}>شماره مرجع</label><input value={form.reference} onChange={e=>setForm(f=>({...f,reference:e.target.value}))} placeholder="شماره بیل / مرجع..." style={{...inp,direction:"ltr" as const}}/></div>
            <div style={{gridColumn:"1/-1"}}><label style={lbl}>شرح</label><input value={form.description} onChange={e=>setForm(f=>({...f,description:e.target.value}))} placeholder="توضیحات..." style={inp}/></div>
          </div>
          <div style={{display:"flex",gap:8,marginTop:14,justifyContent:"flex-end"}}>
            <button onClick={()=>setShowAdd(false)} style={{display:"flex",alignItems:"center",gap:6,padding:"9px 16px",borderRadius:9,border:`1px solid ${T.cardBorder}`,background:"transparent",color:T.text,cursor:"pointer",fontSize:13,fontFamily:"inherit"}}><X size={13}/>انصراف</button>
            <button onClick={handleAdd} style={{display:"flex",alignItems:"center",gap:6,padding:"9px 18px",borderRadius:9,border:"none",background:form.type==="in"?"linear-gradient(135deg,#10b981,#059669)":"linear-gradient(135deg,#ef4444,#dc2626)",color:"white",cursor:"pointer",fontSize:13,fontFamily:"inherit",fontWeight:700}}><Save size={13}/>ثبت {form.type==="in"?"ورود":"خروج"}</button>
          </div>
        </div>
      )}

      {/* فیلترها */}
      <div style={{...card,marginBottom:16}}>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr 1fr auto",gap:10,alignItems:"end"}}>
          <div>
            <label style={lbl}>فیلتر جنس</label>
            <select value={filters.product_id} onChange={e=>setFilters(f=>({...f,product_id:e.target.value}))} style={{...inp,background:dark?"#1e293b":"#f8faff"}}>
              <option value="">همه اجناس</option>
              {products.map(p=><option key={p.id} value={p.id}>{p.name}</option>)}
            </select>
          </div>
          <div>
            <label style={lbl}>فیلتر گدام</label>
            <select value={filters.warehouse_id} onChange={e=>setFilters(f=>({...f,warehouse_id:e.target.value}))} style={{...inp,background:dark?"#1e293b":"#f8faff"}}>
              <option value="">همه گدام‌ها</option>
              {warehouses.map(w=><option key={w.id} value={w.id}>{w.name}</option>)}
            </select>
          </div>
          <div>
            <label style={lbl}>نوع</label>
            <select value={filters.type} onChange={e=>setFilters(f=>({...f,type:e.target.value}))} style={{...inp,background:dark?"#1e293b":"#f8faff"}}>
              <option value="">همه</option>
              <option value="in">ورود</option>
              <option value="out">خروج</option>
            </select>
          </div>
          <div><PersianDatePicker label="از تاریخ" value={filters.from} onChange={v=>setFilters(f=>({...f,from:v}))}/></div>
          <div><PersianDatePicker label="تا تاریخ" value={filters.to} onChange={v=>setFilters(f=>({...f,to:v}))}/></div>
          {!showAdd&&<button onClick={()=>setShowAdd(true)} style={{display:"flex",alignItems:"center",gap:6,padding:"9px 16px",borderRadius:9,border:"none",background:"linear-gradient(135deg,#f59e0b,#d97706)",color:"white",cursor:"pointer",fontSize:13,fontFamily:"inherit",fontWeight:700,whiteSpace:"nowrap"}}><Plus size={14}/>ثبت</button>}
        </div>
      </div>

      {/* جدول */}
      <div style={{borderRadius:14,overflow:"hidden",border:`1px solid ${T.cardBorder}`,background:dark?"rgba(255,255,255,0.02)":"#fff"}}>
        <div style={{display:"grid",gridTemplateColumns:"110px 1fr 130px 90px 110px 100px",gap:8,padding:"11px 16px",background:dark?"rgba(255,255,255,0.04)":"rgba(0,0,0,0.03)",borderBottom:`1px solid ${T.cardBorder}`,fontSize:11,fontWeight:700,color:T.subtext}}>
          <span>تاریخ</span><span>جنس</span><span>گدام</span><span>نوع</span><span>مقدار</span><span>مرجع</span>
        </div>
        {txs.length===0
          ?<div style={{textAlign:"center",padding:60,color:T.subtext}}><div style={{fontSize:40,marginBottom:10}}>📋</div>هیچ تراکنشی یافت نشد</div>
          :txs.map((tx,i)=>(
            <div key={tx.id} style={{display:"grid",gridTemplateColumns:"110px 1fr 130px 90px 110px 100px",gap:8,padding:"11px 16px",borderBottom:`1px solid ${T.cardBorder}`,alignItems:"center",background:i%2===0?"transparent":(dark?"rgba(255,255,255,0.01)":"rgba(0,0,0,0.01)")}}>
              <span style={{fontSize:11,color:T.subtext,direction:"ltr" as const}}>{tx.date?gregorianToJalaliStr(tx.date):"—"}</span>
              <div>
                <div style={{fontSize:13,fontWeight:600,color:T.text}}>{tx.product_name}</div>
                <div style={{fontSize:10,color:T.subtext}}>{tx.product_code}</div>
                {tx.description&&<div style={{fontSize:10,color:T.subtext}}>{tx.description}</div>}
              </div>
              <span style={{fontSize:12,color:T.subtext}}>{tx.warehouse_name}</span>
              <span>
                <span style={{fontSize:11,fontWeight:700,padding:"3px 8px",borderRadius:5,background:tx.type==="in"?"rgba(16,185,129,0.15)":"rgba(239,68,68,0.15)",color:tx.type==="in"?"#10b981":"#ef4444"}}>
                  {tx.type==="in"?"⬇ ورود":"⬆ خروج"}
                </span>
              </span>
              <span style={{fontSize:13,fontWeight:800,color:tx.type==="in"?"#10b981":"#ef4444"}}>{tx.type==="in"?"+":"-"}{fmt(tx.quantity)}</span>
              <span style={{fontSize:11,color:T.subtext,direction:"ltr" as const}}>{tx.reference||"—"}</span>
            </div>
          ))
        }
      </div>
    </div>
  );
}